<template>
  <section class="section--customers">
    <v-container>
      <!-- Header Section -->
      <v-row justify="center pt-7 mt-7" class="header-row">
        <v-col cols="12" class="text-center">
          <h1 class="section-title">
            Customer <span class="underline">Stories</span>
          </h1>
          <p class="section-description">
            Real Success, Real Impact
          </p>
        </v-col>
      </v-row>

      <!-- Stories Section -->
      <stories-section ref="storiesSection" />

      <div class="section-wrapper scheduleNow-section-wrapper">
            <ScheduleNow />
      </div>
    </v-container>
  </section>
</template>

<script>
import StoriesSection from "./Sections/StoriesSection.vue";
import ScheduleNow from '../service/components/GetInTouch.vue';

export default {
  name: "CustomersVue",
  components: {
    "stories-section": StoriesSection,
    "ScheduleNow": ScheduleNow,
  },
  methods: {
      redirectToCalendly() {
        window.open(
            "https://calendly.com/digu/30-minutes-with-digu?month=2024-12",
            "_blank"
        );
      },
      
  },
  created() {
    document.getElementById("loaderSection").classList.add("d-none");
  },
};
</script>

<style scoped>
.section--customers {
  /* Use a linear gradient to split the background */
  background: linear-gradient(
    to bottom,
    #CFECFC 50%, /* Top half */
    #ffffff 50%  /* Bottom half */
  );
  /* padding: 4rem 0; */
  min-height: 60vh; /* Ensure the section takes up the full viewport height */
}

.header-row {
  /* margin-bottom: 4rem; */
}

.section-title {
  font-size: 42px;
  font-weight: 700;
  color: #333;
  position: relative;
  display: inline-block;
}

.underline {
  position: relative;
  display: inline-block;
}

.underline::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: -10px;
  width: 100%;
  height: 10px;
  background-image: url("@/assets/img/underline.svg"); /* Using alias */
  background-repeat: no-repeat;
  background-size: contain;
  transform: translateX(-40%);
}

.section-description {
  font-size: 24px;
  margin-top: 2rem;
  max-width: 600px;
  margin-inline: auto;
}

.footer-row {
  margin-top: 3rem;
}

.footer-title {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin-bottom: 1rem;
}

.connect-button {
  background: #004871;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
}

.connect-button:hover {
  background: #0056b3;
}
</style>

